import apiClient from "./apiClient";
import { API_ROUTES } from "../config/baseURL";

const patientPortalApi = {
  /**
   * Paso 1: Valida el documento de identidad y revisa si ya tiene contraseña
   */
  checkDocument: async (identificacion) => {
    const res = await apiClient.post(API_ROUTES.patientPortalCheckDoc, {
      identificacion: String(identificacion).trim()
    });
    return res.data;
  },

  /**
   * Paso 2A: Crea la contraseña para el paciente nuevo e inicia sesión
   */
  setPassword: async (identificacion, password) => {
    const res = await apiClient.post(API_ROUTES.patientPortalSetPassword, {
      identificacion: String(identificacion).trim(),
      password
    });
    return res.data;
  },

  /**
   * Paso 2B: Inicia sesión con contraseña para paciente registrado
   */
  login: async (identificacion, password) => {
    const res = await apiClient.post(API_ROUTES.patientPortalLogin, {
      identificacion: String(identificacion).trim(),
      password
    });
    return res.data;
  },

  /**
   * Obtiene datos de perfil y grupos de riesgo (Solo GET)
   */
  getResumen: async () => {
    const res = await apiClient.get(API_ROUTES.patientPortalResumen);
    return res.data;
  },

  /**
   * Obtiene actividades, vigencias y porcentaje de cumplimiento (Solo GET)
   */
  getActividades: async () => {
    const res = await apiClient.get(API_ROUTES.patientPortalActividades);
    return res.data;
  }
};

export default patientPortalApi;

